<template>
    <div class="page-wrapper">
        <div class="cg-crumb">
            <span class="item">库存管理</span>
            <em class="gap">/</em>
            <span class="item">库存列表</span>
        </div>
        <div class="cg-main-title">库存列表</div>
        <div class="header-handle">
            <div class="cg-search-box">
                <el-input
                    size="mini"
                    placeholder="ID/商品名称/款号"
                    prefix-icon="el-icon-search"
                    v-model.trim="searchWords"
                    clearable
                    >
                </el-input>
                <button class="cg-btn red" @click="searchHandle">搜索</button>
            </div>
            <div class="btns">
                <button class="cg-btn mgl-16"  @click="exportStockList">下载库存表格</button>
                <button class="cg-btn mgl-16"  @click="openUploadStockPop">上传库存表格</button>
            </div>
        </div>
        <div class="table-wrap cg-table-tr-no-hover">
            <el-table
                :data="tableData"
                :span-method="objectSpanMethod"
                border
                size="small"
                v-loading="loading"
            >
                <el-table-column
                    label="序号"
                    width="50"
                    align="center"
                >
                    <template slot-scope="scope">
                        {{ total - pageSize * (currentPage-1) - scope.row.index }}
                    </template>
                </el-table-column>
                <el-table-column
                    prop="item_id"
                    label="ID"
                    width="80"
                >
                </el-table-column>
                <el-table-column
                    prop="pic"
                    label="图片"
                    width="100"
                >
                    <template slot-scope="scope">
                        <el-image
                            style="width: 64px; height: 64px"
                            :src="scope.row.mallItemFileUrl"
                            fit="cover"
                        >
                        </el-image>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="itemName"
                    label="商品名称"
                    width="120"
                >
                </el-table-column>
                <el-table-column
                    prop="styleNumber"
                    label="款号"
                    width="120"
                >
                </el-table-column>

                <el-table-column
                    prop="stock"
                    :label="'可销总数\nSPU'"
                    width="100"
                >
                </el-table-column>

                <el-table-column
                    prop="color"
                    :label="'颜色'"
                    width="80"
                >
                </el-table-column>
                <el-table-column
                    prop="colorStock"
                    :label="'可销库\n存小计'"
                    width="80"
                >
                </el-table-column>
                <el-table-column
                    prop="size"
                    :label="'尺码'"
                    width="80"
                >
                </el-table-column>
                <el-table-column
                    prop="number"
                    :label="'可销库存'"
                    width="80"
                >
                </el-table-column>
                <!-- <el-table-column
                    prop="lockStock"
                    :label="'锁仓数量'"
                    width="80"
                >
                </el-table-column> -->
                
               
                <el-table-column
                    label="操作"
                    min-width="180"
                >
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="toDetailPage(scope.row)">查看商品</el-button>
                    <el-button type="text" size="small" @click="toEditStock(scope.row)">修改库存</el-button>
                </template>
                </el-table-column>
            </el-table>
            <div class="cg-pagination-wrap">
                <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[5, 10, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                </el-pagination>
            </div>
            
        </div>
        <el-dialog
            title="上传库存表格"
            :visible.sync="uploadStockPop"
            width="600px"
            :close-on-click-modal="false"
            class="upload-stock-pop"
        >
            <el-upload
                class="upload-stock"
                drag
                name="upload_file"
                :action="uploadStockFileApi"
                :data="uploadStockData"
                :show-file-list="false"
                accept=".xlsx,.xls"
                :on-progress="onProgress"
                :on-success="uploadStockSuccess"
                :on-error="uploadStockFail"
                :before-upload="beforeUploadStock"
            >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                <div class="el-upload__tip" slot="tip">
                    只能上传excel文件, 上传模板示例下载：
                    <a :href="uploadExampleLink">库存修改上传表格-模板.xlsx</a>
                </div>
            </el-upload>
            <div class="progress-wrap" v-if="uploadLoading">
                <div class="progress-bar">
                    <div class="progress-bar-inner" :style="{width: uploadProgress + '%'}"></div>
                </div>
                <div class="text">正在上传...</div>
            </div>
        </el-dialog>

        <el-dialog
            title="上传错误提示"
            :visible.sync="uploadStockErrorTip"
            width="600px"
            :close-on-click-modal="false"
            class="upload-stock-error-pop"
        >
            <div class="err-tip">{{uploadStockError.msg}}</div>
            <div>
                <el-table
                    :data="uploadStockError.data"
                    border
                    style="width: 100%"
                >   
                    <el-table-column
                        type="index"
                        width="50">
                    </el-table-column>
                    <el-table-column
                        prop="brandName"
                        label="品牌">
                    </el-table-column>
                    <el-table-column
                        prop="styleNumber"
                        label="款号">
                    </el-table-column>
                </el-table>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { getStockList, exportStockList, uploadStockFileApi } from '../../../api/supplier'
import { mapGetters } from 'vuex'
import { saveAs } from 'file-saver'
import moment from 'moment'
import { getSignStr } from '../../../utils/tools'
export default {
    data() {
        return {
            loading: false,
            searchWords: '',
            tableData: [],
            // 分页
            pageSize: 5,
            total: 0,
            currentPage: 1,
            
            // 上传库存表格相关
            uploadStockPop: false,
            uploadStockFileApi,
            uploadStockData: {
                user_id: ''
            },
            uploadLoading: false,
            uploadProgress: 0, 

            uploadStockErrorTip: false,
            uploadStockError: {
                msg: '',
                data: []
            },
            uploadExampleLink: process.env.VUE_APP_IMG_PREV + '/static/digital_warehouse/%E5%BA%93%E5%AD%98%E4%BF%AE%E6%94%B9%E4%B8%8A%E4%BC%A0%E8%A1%A8%E6%A0%BC-%E6%A8%A1%E6%9D%BF.xlsx',
        }
    },
    computed: {
        ...mapGetters(['userId'])
    },
    inject: ["reload"],
    created() {
        console.log(this.$route.query);
        this.uploadStockData.user_id = this.userId
        let sign = getSignStr(this.uploadStockData)
        this.uploadStockData.sign = sign
    },
    watch: {
        '$route': {
            handler: function (route) {
                this.pageSize = Number(this.$route.query.size) ? Number(this.$route.query.size) : 5
                this.currentPage = Number(this.$route.query.page) ? Number(this.$route.query.page) : 1
                this.searchWords = this.$route.query.search || ''
                this.getStockList()
            },
            immediate: true
        }
    },
    methods: {
        getStockList() {
            this.loading = true
            getStockList({
                page: this.currentPage,
                num: this.pageSize,
                userId: this.userId,
                fuzzyQuery: this.searchWords
            }).then(res => {
                this.loading = false
                console.log('mallItemList-res', res)
                if (res.errorCode == 200) {
                    let tableData = []
                    res.data.mallItemList.forEach((item, item_index) => {
                        try {
                            let sizeArrObj = JSON.parse(item.sizeArr)
                            let sizeArr = sizeArrObj.group
                            let stockSpan = sizeArr.reduce((sum, span) => {
                                return sum + span.sizeArr.length
                            }, 0)
                            sizeArr.forEach((ele, ele_index, ele_array) => {
                                let colorStock = ele.sizeArr.reduce((sum, num) => {
                                    return sum + num.number
                                }, 0)
                                
                                let t = ele.sizeArr.map((size, size_index, size_array) => {
                                    let colorSpan = 0
                                    if (!(ele_index == 0 && size_index == 0)) {
                                        stockSpan = 0
                                    } 
                                    if (size_index == 0) {
                                        colorSpan = size_array.length
                                    }
                                    return {
                                        index: item_index,
                                        itemName: item.itemName,
                                        itemState: item.itemState,
                                        itemUnqueNumber: item.itemUnqueNumber,
                                        item_id: item.item_id,
                                        mallItemFileUrl: process.env.VUE_APP_IMG_PREV + item.mallItemFileUrl,
                                        price: item.price,
                                        styleNumber: item.styleNumber,
                                        user_id: item.user_id,
                                        stock: item.stock,
                                        stockSpan: stockSpan,
                                        color: ele.color,
                                        colorSpan: colorSpan,
                                        colorStock: colorStock,
                                        size: size.name,
                                        number: size.number
                                    }
                                })
                                tableData = tableData.concat(t)
                            })
                        } catch (error) {
                            console.log(error)
                            tableData = tableData.concat({
                                        index: item_index,
                                        itemName: item.itemName,
                                        itemState: item.itemState,
                                        itemUnqueNumber: item.itemUnqueNumber,
                                        item_id: item.item_id,
                                        mallItemFileUrl: item.mallItemFileUrl? process.env.VUE_APP_IMG_PREV + item.mallItemFileUrl:'',
                                        price: item.price || '/',
                                        styleNumber: item.styleNumber,
                                        user_id: item.user_id,
                                        stock: item.stock || '0',
                                        stockSpan: 1,
                                        color: '/',
                                        colorSpan: 1,
                                        colorStock: '/',
                                        size: '/',
                                        number: '/'
                                    })
                        }
                        
                    });
                    console.log(tableData)
                    this.tableData = tableData
                    this.total = parseInt(res.data.totalCount)
                } else if (res.errorCode == -10111) {
                    // 暂无商品列表
                    this.tableData = []
                    this.total = 0
                    this.$message.error(res.errorMsg || '暂无商品列表')
                } else {
                    this.$message.error(res.errorMsg || '获取列表数据失败')
                }
            }).catch(err => {
                this.loading = false
                console.log(err)
            })
        },
        toDetailPage(row) {
            console.log(row);
            this.$router.push('/supplier/goods/detail?id=' + row.item_id)
        },
        searchHandle() {
            this.currentPage = 1
            this.curRoutePush()
        },
        handleSizeChange(val) {
            this.pageSize = val
            this.currentPage = 1
            this.curRoutePush()
        },
        handleCurrentChange(val) {
            this.currentPage = val
            this.curRoutePush()
        },
        curRoutePush() {
            this.$router.push('/supplier/stock/list?search=' + this.searchWords + 
            '&page=' + this.currentPage + 
            '&size=' + this.pageSize).catch(err => {err})
        },
        toEditStock(row) {
            this.$router.push('/supplier/stock/edit?id=' + row.item_id)
        },
        // 合并表格
        objectSpanMethod({ row, column, rowIndex, columnIndex }) {
            //   console.log(row, column, rowIndex, columnIndex)
            
            if (columnIndex == 6 || columnIndex == 7) {
                if (row.colorSpan && row.colorSpan >= 1) {
                        return {
                            rowspan: row.colorSpan,
                            colspan: 1
                        };
                } else {
                    return {
                        rowspan: 0,
                        colspan: 0
                    };
                }
            }
            if (columnIndex <= 5 || columnIndex == 10) {
                if (row.stockSpan && row.stockSpan >= 1) {
                        return {
                            rowspan: row.stockSpan,
                            colspan: 1
                        };
                } else {
                        return {
                            rowspan: 0,
                            colspan: 0
                        };
                }
            }
        },
        // 导出库存表格
        exportStockList() {
            exportStockList({
                user_id: this.userId,
                image_type: 12104,
                item_state: '',
            }).then(res => {
                console.log(res)
                if (res.error_code == 0) {
                    this.$message.success('成功获取下载链接！')
                    saveAs(res.data.file, `zciiss数字云仓_库存_${moment().format("YYYY年MM月DD日HH时mm分")}`);
                    // window.location.href=res.data.file;
                } else {
                    this.$message.error(res.error_msg || '下载失败！')
                }
            }).catch(err => {
                console.log(err)
            })
        },

        // 上传库存表格
        openUploadStockPop() {
            this.uploadStockPop = true
        },
        beforeUploadStock(file) {
            console.log(file);

            const isExcel = file.type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            || file.type == 'application/vnd.ms-excel';
            const isLimit = file.size / 1024 / 1024 < 20;
            if (!isExcel) {
                this.$message.error("请上传Excel格式的文件!");
                return false
            }
            if (!isLimit) {
                this.$message.error("上传Excel大小不能超过 20MB!");
                return false
            }
            this.uploadLoading = true
            this.uploadProgress = 0
            return isExcel && isLimit;
        },
        onProgress(e, file, fileList) {
            console.log(e, file, fileList)
            this.uploadProgress = e.percent
        },
        uploadStockSuccess(res, file) {
            setTimeout(() => {
                this.uploadLoading = false
                console.log(res, file);
                if (res.error_code == 0) {
                    this.uploadStockPop = false
                    this.$message.success('上传成功！')
                    this.reload()
                } else if (res.error_code == -2) {
                    this.uploadStockErrorTip = true;

                    this.uploadStockError.msg = res.error_msg
                    this.uploadStockError.data = res.data
                } else {
                    this.$message({
                        showClose: true,
                        message: res.error_msg || '网络异常',
                        type: 'error',
                        duration: 0
                    })
                    // this.$message.error(res.error_msg || '网络异常')
                }
            }, 500)
        },
        uploadStockFail(err) {
            console.log(err)
            setTimeout(() => {
                this.uploadLoading = false
                this.$message.error('上传失败！')
            }, 500)
        }
    },
}
</script>

<style lang="scss" scoped>
.page-wrapper {
  padding: 24px 24px;
}
.header-handle {
    margin-top: 24px;
    padding: 20px 24px;
    height: 28px;
    background: #fff;
    .cg-search-box {
        float: left;
    }
    .btns {
        float: right;
    }
}
.table-wrap {
    margin-top: 8px
}
.upload-stock {text-align: center;}
.progress-wrap {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background: rgba($color: #ffffff, $alpha: 0.9);
   
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .progress-bar {
        width: 400px;
        height: 30px;
        background: #ccc;
        border-radius: 6px;
        overflow: hidden;
        position: relative;
    }
    .progress-bar-inner {
        position: absolute;
        left: 0;
        top: 0;
        width: 0;
        height: 30px;
        background: #F56C6C;
        transition: width 0.5s;
    }
    .text {
        font-size: 13px;
        color: #333;
        margin-top: 12px;
    }
}
.upload-stock-error-pop {
    .err-tip {
        font-size: 14px;
        color: #F56C6C;
        font-weight: bold;
        margin-bottom: 20px;
    }
}
</style>